export default import.meta.ROLLDOWN_FILE_URL_LKnOUAwndhao8Kp5JA7cbg